var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "No_Transaction",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 513.179,
    height: 501.17,
    viewBox: "0 0 513.179 501.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2923",
    "data-name": "Rectangle 2923",
    width: 513.179,
    height: 501.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8082",
    "data-name": "Path 8082",
    d: "M296.051,399.909A51.548,51.548,0,1,0,347.634,348.4h-.039a51.548,51.548,0,0,0-51.544,51.511",
    transform: "translate(-296.051 -348.398)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8131",
    "data-name": "Path 8131",
    d: "M340.488,264.4l-.014,5.215,41.581-12.708-.229-4.1Z",
    transform: "translate(-340.474 -252.814)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7.461,
    y1: 16.115,
    x2: -7.439,
    y2: 16.115,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aab2c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#858d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8135",
    "data-name": "Path 8135",
    d: "M235.019,207.409l6.713,47.206,89.39,5.4-6.888-48.552a3.545,3.545,0,0,0-3.295-3.077l-82.2-4.969c-.072,0-.143-.006-.213-.006a3.542,3.542,0,0,0-3.507,4",
    transform: "translate(-234.989 -203.413)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.219,
    y1: 5.579,
    x2: -2.21,
    y2: 5.579,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8142",
    "data-name": "Path 8142",
    d: "M51.231,316.727c-2.7,1.454-5.2,14.233-4.88,17.492.131,1.391.31,2.8.518,4.194.074.606.179,1.216.281,1.813a147.264,147.264,0,0,0,3.872,16.488c.309.2.617.4.949.58,3.478,1.936,11.471,5.507,10.889,5.736a17.648,17.648,0,0,1-9.56.819,61.659,61.659,0,0,0,6.672,13.457c5.234,3.5,18.021,8.728,17.369,8.922a36.1,36.1,0,0,1-8.116,1.358,52.383,52.383,0,0,0,8.926,6.061c6.615,3.6,14.743,5.378,19.731,10.963a.465.465,0,0,0,.393.178.587.587,0,0,0,1.021,0c8.256-14.983,4.413-31.41.775-46.152-.173-.7-.343-1.389-.529-2.085a52.179,52.179,0,0,1-8.259,12.128c-.483.515,3.252-14.335,5.21-21.267a30.372,30.372,0,0,0-5.962-9.165c-5.479-5.666-12.835-10.107-19.85-14.1-.283-.167-.6-.313-.878-.478a33.718,33.718,0,0,1-2,10.453c-.216.6-2.43-8.862-3.242-13.26-1.7-.849-3.4-1.7-5.137-2.484-1.717-.8-3.9-2.185-6.064-2.185a4.364,4.364,0,0,0-2.125.53",
    transform: "translate(-46.324 -316.197)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.681,
    y1: 2.393,
    x2: -0.667,
    y2: 2.393,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8145",
    "data-name": "Path 8145",
    d: "M168.511,348.795c-.728,2.126-2.739,6.961-2.948,6.55a23.961,23.961,0,0,1-1.864-5.385c-1.523.435-3.023.895-4.491,1.451-.095,3.159-.732,10.3-.993,9.746a30.873,30.873,0,0,1-2.512-8.339c-1.556.682-3.081,1.437-4.548,2.254q-.656.364-1.275.729a52,52,0,0,0-4.556,3.024c-.39.281-.77.584-1.15.889a41.891,41.891,0,0,0-5,4.6c-.67.72-1.3,1.464-1.928,2.232-.487,3.784-1.222,12.119-1.563,11.774a11.339,11.339,0,0,1-2.706-5.349,38.3,38.3,0,0,0-4.312,12.631c-.936,6.337,2.837,17.452,5.3,23.526a27.134,27.134,0,0,0,1.968,4.275,1.674,1.674,0,0,0,1.688-.724c7.151-9.944,14.3-20.35,22.584-29.369,7.034-7.651,16.315-11.2,25.821-14.722,4.3-1.589,17.824-4.422,17.912-10.271a1.057,1.057,0,0,0-.005-.179c-.215-6.3-11.2-9.252-15.858-9.977-1.26-.194-2.546-.342-3.845-.431-.4-.039-.816-.056-1.229-.074q-1.35-.07-2.718-.069a59.8,59.8,0,0,0-11.772,1.2",
    transform: "translate(-128.519 -347.591)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.526,
    y1: 2.798,
    x2: -1.514,
    y2: 2.798,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8801",
    "data-name": "Group 8801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8800",
    "data-name": "Group 8800",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8070",
    "data-name": "Path 8070",
    d: "M10.335,274.395s2.912,90.273,78.27,150.443,179.781,64.478,264.317,70.194,149.465-42.14,159.252-114.48-54.81-93.576-89.857-175.921S390.388,95.217,316.232,44.57,126.072,25.023,65.25,111.787,10.335,274.395,10.335,274.395",
    transform: "translate(-0.904 -1.793)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8071",
    "data-name": "Path 8071",
    d: "M10.335,274.395s2.912,90.273,78.27,150.443,179.781,64.478,264.317,70.194,149.465-42.14,159.252-114.48-54.81-93.576-89.857-175.921S390.388,95.217,316.232,44.57,126.072,25.023,65.25,111.787,10.335,274.395,10.335,274.395Z",
    transform: "translate(-0.904 -1.793)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8072",
    "data-name": "Path 8072",
    d: "M203.49,324.967l-.039,59.5-.065,84.849v2.942a7.786,7.786,0,0,0,7.773,7.795l11.545.008,38.226.026,20.408.011,12.246.011,173.887.116a7.8,7.8,0,0,0,7.8-7.774l.09-147.288a7.785,7.785,0,0,0-7.774-7.8l-2.232,0-12.246-.011-21.417-.011-52.949-.034-12.24,0-20.412-.018-2.248-.007-43-.023-89.568-.059a7.774,7.774,0,0,0-7.782,7.775",
    transform: "translate(-18.057 -28.161)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8073",
    "data-name": "Path 8073",
    d: "M399.147,399.982A51.548,51.548,0,1,1,347.634,348.4a51.545,51.545,0,0,1,51.513,51.584",
    transform: "translate(-26.284 -30.932)",
    fill: "#aab2c5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8803",
    "data-name": "Group 8803",
    transform: "translate(269.767 317.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8802",
    "data-name": "Group 8802",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8074",
    "data-name": "Path 8074",
    d: "M392.2,418.389a12.66,12.66,0,0,0-2.091-1.225,2.75,2.75,0,0,0-2.04.652c-.436.289-.836.575-1.207.862a4.489,4.489,0,0,0,.524-.655c.508-.653.624-1.615,1.1-2.306a3.5,3.5,0,0,1,1.668-1.476,2.1,2.1,0,0,1,2.971,1.344,2.832,2.832,0,0,1-.262,1.64c-.156.4-.467.772-.662,1.164",
    transform: "translate(-304.113 -354.228)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8075",
    "data-name": "Path 8075",
    d: "M404.633,410.86c-.3.734-.919.778-1.525,1.129-2.23,1.283-1.936,2.6-2.25,4.752-.343,2.363-1.817,3.783-3.688,5.124-.813.586-2.93,1.513-3.217,2.378-.635,1.894,1.814,1.7,2.887,2.309,2.046,1.158,1.863,3,1.185,4.96-1.339,3.873-2.9,7.764-4.577,11.505-.48,1.074-.938,2.495-1.911,3.241-1.653,1.268-3.316-.057-4.717,2.419-1.421,2.512.481,6.642-2.094,8.8-2.193,1.831-5.654-1.421-7.507-2.469a.468.468,0,0,1-.223-.268,11.521,11.521,0,0,0-5.406-1.791c-1.966,0-3.214,1.361-4.933,1.979a4,4,0,0,1-4.758-1.539c-.277-.4-.373-1.141-.665-1.492a6.087,6.087,0,0,0-4.612-1.5,4.233,4.233,0,0,1-2.548-.3,2.419,2.419,0,0,1-1.136-1.276c-.226-.573.026-1.185-.057-1.756a3.83,3.83,0,0,0-2.979-3.476.529.529,0,0,1-.368-.648,3.961,3.961,0,0,1,1.079-1.514c1.222-.056,2.437.057,3.673-.029.458-.034.99-.406.933-.932-.169-1.575-.632-1.672-1.789-2.645-.481-.2-.967-.406-1.453-.612a2.386,2.386,0,0,1-.619-2.508,4.139,4.139,0,0,1-.159-1c4.566-.473,10.7,2.462,14.688-.4.66-.474,1.072-1.307,1.736-1.75,4.1-2.751,2.338-.4,4.909-.687,2.13-.243,3.236-.252,4.933-1.7,1.713-1.463,2.294-2.919,3.158-4.829.533-1.177,3.357-5.778,5.106-6.221,2.169-.544,3.889,3.977,5.8-.036a.923.923,0,0,0,.07-.564,6.519,6.519,0,0,1,1.647-1.8,13.828,13.828,0,0,0,2.387-1.474c1-1.046.97-2.428.943-3.735-.055-2.9-.356-5.392,1.2-8.016.718-1.206,2.592-3.672,4.346-2.75a1.762,1.762,0,0,1,.733.918c.012.272.026.545.04.816a2.672,2.672,0,0,0,.87,1.784,6.454,6.454,0,0,1,.4.795,6.716,6.716,0,0,1-.084,2.48c-.088,3.366.486,1.489.6,3.241a2.409,2.409,0,0,1-.048,1.081",
    transform: "translate(-300.797 -352.939)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8076",
    "data-name": "Path 8076",
    d: "M342.57,452.211c-.395-1.583-1.576-2.757-2.524-4.043-.289-.392-1.378-1.576-1.289-2.118.144-.908,1.678-1.168,2.258-.96a6.408,6.408,0,0,1,1.76,1.423,5.829,5.829,0,0,0,.85.9c.824.7,2.15,1.172,2.819,2.073a2.624,2.624,0,0,1,.471,1.684c.089.909-.32,1.992.028,2.927.112.305.744.907,1,1.309.811,1.283.9,2.694-.45,3.675a3.031,3.031,0,0,1-2.869.35,7.468,7.468,0,0,1-1.782-2.875,21.6,21.6,0,0,0-.268-4.35",
    transform: "translate(-299.842 -356.977)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8077",
    "data-name": "Path 8077",
    d: "M326.89,431.6a23.444,23.444,0,0,1-3.879,1.3c-1.576.5-6.278,1.036-4.8,3.464a2.259,2.259,0,0,0,.725,1.9,3.65,3.65,0,0,0,2.412.952c.095.015.184.031.286.045a7.92,7.92,0,0,1,3.8,1.176c.429.344.743.827,1.148,1.2.456.425.835.5,1.062,1.108a9.706,9.706,0,0,0,.339,1.128,12.025,12.025,0,0,1,.993,1.678c.161.857.044,1.681-.789,1.678-.483-.235-.95-.423-1.391-.636-.519-.389-1.022-.855-1.36-1.126a.661.661,0,0,0-.144-.071,3.786,3.786,0,0,1-.34-.591c-.533-1.138-.824-2.007-2.062-2.456a3.275,3.275,0,0,0-1-1.113,2.188,2.188,0,0,0-2.294-.106c-.4.207-.528.591-1.038.711a10.856,10.856,0,0,1-1.188-.046c-1.157.1-2.8.655-2.994,1.981a1.736,1.736,0,0,0,.186,1.059,12.137,12.137,0,0,0,1.706,3.349.479.479,0,0,1-.23.715,2.1,2.1,0,0,1-1.261,2.231c-1.781.835-3.806-.713-5.171-1.674-4.271-3.019-7.07-7.006-9.512-11.553a61.984,61.984,0,0,0-4.478-7.011,17.771,17.771,0,0,1-3.275-6.178,8.635,8.635,0,0,1,.375-5.055,7.12,7.12,0,0,1,.671-1.272,27.865,27.865,0,0,1,4.9-2.708c1.31-.529,2.668-1,3.475-2.231,1.606-2.453.011-5.536-1.751-7.571a10.924,10.924,0,0,1,.073-3.8A20.9,20.9,0,0,1,302.01,399c.963-1.267,2.34-2.6,2.72-4.2.431-1.842-.749-2.957-1.537-4.425-.888-1.646-.977-3.09.433-4.4,1.476-1.372,1.3-3.18,2.576-4.685a29.893,29.893,0,0,1,2.263-2.029,5.417,5.417,0,0,0,1.666-5.473c-.7-3.57-2.487-8.539,2.028-10.48,2.476-1.066,6.451.477,6.158,3.615a21.55,21.55,0,0,0-.416,2.326,5.5,5.5,0,0,0,1.042,3.232c.692,1.089,1.61,2.019,2.353,3.074a6.427,6.427,0,0,1,1.145,6.2c-.56,1.764-1.425,3.06-.663,5,.484,1.231,1.555,2.172,2.267,3.28.906,1.4,2.612,4.389,2.076,6.154-.46,1.5-3.03,2.24-4.319,2.673a15.78,15.78,0,0,1-2.673.642,15.565,15.565,0,0,0-2.953.293c-.93.371-1.432,1.564-1.967,2.31a17.848,17.848,0,0,1-4.215,4,5.974,5.974,0,0,1-2.4,1.134,13.559,13.559,0,0,0-1.386.1c-2.968.967-1.462,1.595-1.03,3.13.512,1.811-.246,2.521-1.515,3.837-1.061,1.1-2.151,2.163-3.217,3.252-.118.124-.237.244-.356.365q-1.816,1.338.564,3.481c.75-.127,1.5-1.81,1.846-2.4a5.073,5.073,0,0,1,3.154-2.635,24.437,24.437,0,0,0,3.23-1.5,2.346,2.346,0,0,1,2.074.01c1.822.79,1.979,2.779,3.023,4.218,1.143,1.575,3.331,2.329,5.129,2.84,1.291.367,2.955-.077,4.151.433.574.246.826.836,1.125,1.34.944,1.587,1.834,3.222,2.721,4.839.708,1.293,1.3,2.257-.215,3.059",
    transform: "translate(-295.703 -349.692)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8078",
    "data-name": "Path 8078",
    d: "M374.449,416.258c.156,2.3-1.717,3.944-3.617,4.821a51.956,51.956,0,0,1-9.087,3.065,22.183,22.183,0,0,1-3.966.293,5.577,5.577,0,0,0-3.386,1.475,11.054,11.054,0,0,1-.991,1.035,2.5,2.5,0,0,1-2.107.457,21.316,21.316,0,0,0-2.719-.681c-.864-.062-1.736.106-2.6,0a3.926,3.926,0,0,1-3.325-2.04c-2.125.664-4.207-.753-5-2.991-1.111-3.146.324-5.806,2.328-8.127a10.254,10.254,0,0,0,1.315-1.629,3.843,3.843,0,0,0-.122-2.687,3.323,3.323,0,0,1,.2-1.6,3.057,3.057,0,0,1,2.109-1.661c1.858-.452,2.688.844,4.172,1.383a6.779,6.779,0,0,0,.9.256,4.631,4.631,0,0,0,2.819.868c2.684-.056,4.153-1.688,4.891-4.146a39.283,39.283,0,0,0,1.682-7.98c.141-1.945-1.442-3.015-2.587-4.216a5.056,5.056,0,0,0-.291-1.393,2,2,0,0,1-.183-.7,1.842,1.842,0,0,1,.347-.987c.5-.826,1.343-1.148,1.823-2.1a5.294,5.294,0,0,0-.158-4.8c-.372-.861-.811-1.684-.331-2.6,1.188-2.272,4.494.33,5.616,1.434a10.024,10.024,0,0,1,2.523,4.06c.8,2.532.331,4.964,2.429,7a.534.534,0,0,1-.107.826c-2.016,1.523,1.011,3.995,1.894,5.2a12.188,12.188,0,0,1,1.986,3.764,8.037,8.037,0,0,1,.252,3.573c-.289,1.639-2.149,3.566-1.472,5.2.991,2.391,4.549,2.629,4.75,5.617",
    transform: "translate(-299.711 -351.086)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8079",
    "data-name": "Path 8079",
    d: "M378.075,390.771c-.212-.441-.585-.561-.922-.867-.846-.764-.622-.96-.826-1.963a2.888,2.888,0,0,0-1.786-2.154c-2.385-.784-2.643,2.745-1.985,4.2.344.758.9,1,1.35,1.639.545.78.117,1.018,0,1.812a3.661,3.661,0,0,0,1.317,3.041.163.163,0,0,1,0,.026c.034.09.071.18.1.267a.552.552,0,0,0,.5.388,1.253,1.253,0,0,0,.162-.009.569.569,0,0,0,.8-.441,5.764,5.764,0,0,0,.531-1.654c.309-1.136,1.3-3.114.739-4.284",
    transform: "translate(-302.816 -351.708)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8080",
    "data-name": "Path 8080",
    d: "M406.97,378.607c-3.185-1.933-4.514-4.47-6.306-7.562-1.361-2.361-3.881-3.3-5.446-5.522-3-4.257-6.367-7.169-11.8-7.538a.532.532,0,0,0-.527.527c-.071,1.835,1.1,2.694,2.663,3.415A8.608,8.608,0,0,1,390,365.659c.934,1.825.255,3.051-1.145,4.251-.96.822-1.752,1.788-1.237,3.115.82,2.127,3.757,2.294,1.411,4.927-3.234,3.626,2.752,4.54,5.143,6.219,1.246.875,3.122,3.507,4.933,3.431a1.681,1.681,0,0,0,1.747-1.4c3.678.589,5.265-3.44,5.9-6.511a.525.525,0,0,0,0-.113.531.531,0,0,0,.212-.971",
    transform: "translate(-303.761 -349.249)",
    fill: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8081",
    "data-name": "Path 8081",
    d: "M374.054,350.268c-.4-2.362-5.253-2.67-6.962-3.127a125.917,125.917,0,0,0-13.155-2.981c-2.154-.335-18.562-2.242-17.157,2.231a.474.474,0,0,0,.166.24,7.651,7.651,0,0,0-1.924,3.618,4.574,4.574,0,0,0,.179,1.84,6.36,6.36,0,0,1,.449,2.03c-.039.445-.385.826-.408,1.3-.128,2.65,2.583,1.822,4.064,1.142a22.845,22.845,0,0,1,6.447-1.791c2.682-.38,4.239.978,6.572,1.783,2.768.958,4.964-.375,6.677-2.487,1.074-1.327,2.149-2.3,4.15-1.92.642.119,1.22.68,1.884.837,1.565.373,3.083-.4,4.67-.376,1.481.017,4.788.226,4.349-2.335",
    transform: "translate(-299.508 -347.961)",
    fill: "#eaf4fe"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8805",
    "data-name": "Group 8805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8804",
    "data-name": "Group 8804",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2924",
    "data-name": "Rectangle 2924",
    width: 86.761,
    height: 7.044,
    transform: "translate(351.555 423.003)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2925",
    "data-name": "Rectangle 2925",
    width: 86.758,
    height: 7.044,
    transform: "translate(351.568 405.242)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8083",
    "data-name": "Path 8083",
    d: "M309.746,317.271,239.728,451.12l-15.144,28.944,38.226.026,31.833-60.864,4.916-9.4,33.215-63.485,15.192-29.053-2.248-.007Z",
    transform: "translate(-19.939 -28.168)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8084",
    "data-name": "Path 8084",
    d: "M374.093,317.31l-15.507,29.645-21.353,40.819-24.9,47.594-23.4,44.736,12.246.011,20.017-38.278,35.2-67.286,12.548-24,17.389-33.237Z",
    transform: "translate(-25.652 -28.172)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8085",
    "data-name": "Path 8085",
    d: "M481.395,317.355l-12.24-.011L384,480.139l12.243.008Z",
    transform: "translate(-34.092 -28.175)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8086",
    "data-name": "Path 8086",
    d: "M466.184,333.983l-46.99-.033a5.012,5.012,0,0,0-5.016,5.009l-.02,27.019a5.014,5.014,0,0,0,5.01,5.016l46.991.033a5.015,5.015,0,0,0,5.017-5.011L471.195,339a5.012,5.012,0,0,0-5.011-5.015",
    transform: "translate(-36.77 -29.649)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M97.734,213.3a4.734,4.734,0,0,1-4.726-4.733V60.712a6.2,6.2,0,0,1,6.19-6.2H302.169a6.2,6.2,0,0,1,6.2,6.19V208.571a4.738,4.738,0,0,1-4.734,4.733Z",
    transform: "translate(-8.257 -4.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M97.734,213.3a4.734,4.734,0,0,1-4.726-4.733V60.712a6.2,6.2,0,0,1,6.19-6.2H302.169a6.2,6.2,0,0,1,6.2,6.19V208.571a4.738,4.738,0,0,1-4.734,4.733Z",
    transform: "translate(-8.257 -4.84)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M302.113,55.023a5.637,5.637,0,0,1,5.635,5.627V208.516a4.174,4.174,0,0,1-4.17,4.171H97.678a4.171,4.171,0,0,1-4.162-4.171V60.658a5.637,5.637,0,0,1,5.627-5.635Zm0-1.125H99.142a6.758,6.758,0,0,0-6.752,6.76V208.516a5.294,5.294,0,0,0,5.288,5.3h205.9a5.3,5.3,0,0,0,5.3-5.3V60.65a6.759,6.759,0,0,0-6.761-6.752",
    transform: "translate(-8.203 -4.785)",
    fill: "#034f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M308.87,77.173H92.387V60.655A6.758,6.758,0,0,1,99.146,53.9H302.113a6.757,6.757,0,0,1,6.758,6.757Z",
    transform: "translate(-8.202 -4.785)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M133.25,66.32a3.575,3.575,0,1,1,3.574,3.575,3.574,3.574,0,0,1-3.574-3.575",
    transform: "translate(-11.83 -5.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M133.25,66.32a3.575,3.575,0,1,1,3.574,3.575A3.574,3.574,0,0,1,133.25,66.32Z",
    transform: "translate(-11.83 -5.571)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M118.153,66.32a3.575,3.575,0,1,1,3.575,3.575,3.574,3.574,0,0,1-3.575-3.575",
    transform: "translate(-10.49 -5.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M118.153,66.32a3.575,3.575,0,1,1,3.575,3.575A3.574,3.574,0,0,1,118.153,66.32Z",
    transform: "translate(-10.49 -5.571)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M106.576,70.4a4.137,4.137,0,1,1,4.138-4.137,4.142,4.142,0,0,1-4.138,4.137",
    transform: "translate(-9.095 -5.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M106.576,70.4a4.137,4.137,0,1,1,4.138-4.137A4.142,4.142,0,0,1,106.576,70.4Z",
    transform: "translate(-9.095 -5.516)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M106.522,62.636a3.575,3.575,0,1,1-3.576,3.575,3.574,3.574,0,0,1,3.576-3.575m0-1.126a4.7,4.7,0,1,0,4.7,4.7,4.707,4.707,0,0,0-4.7-4.7",
    transform: "translate(-9.04 -5.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M315.489,68.643l-2.528,2.528L310.4,68.606l2.528-2.528L310.4,63.55l2.565-2.565,2.528,2.528,2.527-2.529,2.565,2.566-2.527,2.528,2.527,2.528-2.565,2.565Z",
    transform: "translate(-27.558 -5.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M317.939,61.7l1.769,1.77L317.181,66l2.527,2.528-1.769,1.77-2.528-2.528L312.883,70.3l-1.769-1.77L313.642,66l-2.528-2.528,1.769-1.77,2.529,2.528Zm0-1.591-.8.8-1.732,1.732-1.732-1.732-.8-.8-.8.8-1.769,1.77-.8.8.8.8L312.051,66l-1.732,1.732-.8.8.8.8,1.769,1.77.8.8.8-.8,1.732-1.732,1.732,1.732.8.8.8-.8,1.77-1.77.795-.8-.795-.8L318.772,66l1.732-1.732.795-.8-.795-.8-1.77-1.77Z",
    transform: "translate(-27.48 -5.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8100",
    "data-name": "Path 8100",
    d: "M243.851,391.612l2.4,17.055,5.535-.855,5.609-16.763Z",
    transform: "translate(-21.65 -34.718)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8101",
    "data-name": "Path 8101",
    d: "M243.744,408.393s-26.9,18.292-22.965,35.1l42.742-29.056s-2.87-11.731-12.714-10.249c0,0-.567,4.126-7.062,4.21",
    transform: "translate(-19.566 -35.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8102",
    "data-name": "Path 8102",
    d: "M243.744,408.393s-26.9,18.292-22.965,35.1l42.742-29.056s-2.87-11.731-12.714-10.249C250.806,404.183,250.239,408.309,243.744,408.393Z",
    transform: "translate(-19.566 -35.873)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M262.725,413.679l-29.4,19.991a22.116,22.116,0,0,0-7.688-7.148c-.3-.169-.533.318-.231.487a21.532,21.532,0,0,1,7.478,6.96l-12.786,8.69a.27.27,0,0,0,.3.447l12.779-8.687c.214.34.457.656.658,1.012.168.3.613,0,.445-.306-.2-.351-.447-.666-.662-1.006l29.414-19.994a.271.271,0,0,0-.3-.448",
    transform: "translate(-19.53 -36.723)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M237.569,413.685a.226.226,0,0,0,.057-.25c-1.1-3.08-10.46-8.837-12.293-3.689-.624,1.757.79,3.752,2.247,4.78.261,1.59,2.33,2.573,3.766,2.671a5.245,5.245,0,0,0,3.145-.873.208.208,0,0,0,.182.148,6.872,6.872,0,0,1,5.27,3.309c.178.3.623-.005.443-.3a7.351,7.351,0,0,0-5.4-3.487,16.193,16.193,0,0,0,2.062-1.812.705.705,0,0,1,.081-.02c.016-.007.02-.021.032-.027a.333.333,0,0,0,.1.043c.015,0,.023.017.046.021a7.024,7.024,0,0,1,5.889,3.493c.176.3.623-.005.447-.3a7.57,7.57,0,0,0-6.075-3.7m-11.584-2.133c-1.181-4.2,3.987-3.245,6.061-2.2,1.693.854,3.833,1.93,4.795,3.676a7.789,7.789,0,0,0-4.993-1.82c-1.618-.069-4.026.849-4.271,2.7a4.1,4.1,0,0,1-1.591-2.355m10.737,2.158c-2.489.642-6.2,1.694-8.612.513a2.35,2.35,0,0,1,1.328-1.914,4.756,4.756,0,0,1,3.4-.454,6.312,6.312,0,0,1,3.888,1.854m-3.517,2.675c-1.513.552-3.871.266-4.8-1.253-.04-.067-.029-.123-.06-.184,2.21,1.024,5.235.191,7.663-.486a8.276,8.276,0,0,1-2.8,1.923",
    transform: "translate(-19.992 -36.195)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M396.905,301.361c.162,1.487-15.509,12.441-16.724,12.486-21.261,4.253-77.372-7.08-92.769,2.87a10.373,10.373,0,0,0-2.823,2.694c-12.246,17-29.108,60.049-30.429,63.475a1.086,1.086,0,0,1-.046.127.168.168,0,0,0-.035.073l-.011.025-.013-.005-7.746-2.863s-13.537-44.413-9.7-85.527c3.644-39.027,75.359-34.33,75.359-34.33s12.123-.278,22.171,7.12c1.8-2.332,15.068,17.523,15.068,17.523l26.638-7s18.727,2.535,21.059,23.334",
    transform: "translate(-20.946 -23.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M396.905,301.361c.162,1.487-15.509,12.441-16.724,12.486-21.261,4.253-77.372-7.08-92.769,2.87a10.373,10.373,0,0,0-2.823,2.694c-12.246,17-29.108,60.049-30.429,63.475a1.086,1.086,0,0,1-.046.127.168.168,0,0,0-.035.073l-.011.025-.013-.005-7.746-2.863s-13.537-44.413-9.7-85.527c3.644-39.027,75.359-34.33,75.359-34.33s12.123-.278,22.171,7.12c1.8-2.332,15.068,17.523,15.068,17.523l26.638-7S394.573,280.561,396.905,301.361Z",
    transform: "translate(-20.946 -23.102)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M288.789,315.518a6.093,6.093,0,0,0-2.823,2.694c-14.887,28.114-29.121,60.5-30.429,63.475a1.314,1.314,0,0,1-.046.127.286.286,0,0,0-.035.073c-.006.012-.012.025-.012.025l-.013-.006c-.4-.26-11.523-38.827,5.144-95.918,14.981-51.355,85.884.049,88.661,4.074l52.218,10.1c.162,1.487-7.01,3.577-7.268,5.242Z",
    transform: "translate(-22.322 -23.378)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8108",
    "data-name": "Path 8108",
    d: "M240.531,393.538a3.149,3.149,0,0,1-.466-4.593,7.921,7.921,0,0,1,.591-3.082c.57-.859,20.758,3.182,21.043,6.181s-1.854,3.225-1.854,3.225,1.829,2.592-.858,2.49-12.452-.4-18.456-4.221",
    transform: "translate(-21.241 -34.247)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8109",
    "data-name": "Path 8109",
    d: "M269.487,298.372c5.009,40.988,26.28,81.966,26.28,81.966l8.157,1.288h.01a.035.035,0,0,0,.011-.021.144.144,0,0,1,.021-.085c0-.032.022-.074.022-.127.622-3.624,8.717-49.135,17.392-68.208a10.231,10.231,0,0,1,3.2-4.036c11.792-8.95,44.221,4.87,66.083,5.262.011,0,.011-.011.022-.011,32.217-13.187,16.367-42.784,16.367-42.784-6.509-4.85-18.83-6.891-18.83-6.891l-49.314-4.574c-24.832,1.405-74.929-7.07-69.423,38.219",
    transform: "translate(-23.888 -23.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M269.487,298.372c5.009,40.988,26.28,81.966,26.28,81.966l8.157,1.288h.01a.035.035,0,0,0,.011-.021.144.144,0,0,1,.021-.085c0-.032.022-.074.022-.127.622-3.624,8.717-49.135,17.392-68.208a10.231,10.231,0,0,1,3.2-4.036c11.792-8.95,44.221,4.87,66.083,5.262.011,0,.011-.011.022-.011,32.217-13.187,16.367-42.784,16.367-42.784-6.509-4.85-18.83-6.891-18.83-6.891l-49.314-4.574C314.078,261.558,263.982,253.083,269.487,298.372Z",
    transform: "translate(-23.888 -23.097)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8111",
    "data-name": "Path 8111",
    d: "M300.736,378.822v.011h.01c3.012,4.86,5.781,5.991,5.96,6.065h.01a.038.038,0,0,0,.011-.022.16.16,0,0,1,.021-.084c0-.032.021-.075.021-.127.074-.328.3-1.268.645-2.705,3.053-12.617,15.606-63.2,17.022-64.034,14.117-10.715,44.454,7.545,64.193,0,0,0,2.774,3.434,16.628-7.427-5,1.341-15.391,7.892-35.119,3.845-25.878-5.305-56.8-29.439-64.235-9.721-7.375,19.547-5.209,73.226-5.167,74.2",
    transform: "translate(-26.671 -26.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8112",
    "data-name": "Path 8112",
    d: "M300.736,378.822v.011h.01c3.012,4.86,5.781,5.991,5.96,6.065h.01a.038.038,0,0,0,.011-.022.16.16,0,0,1,.021-.084c0-.032.021-.075.021-.127.074-.328.3-1.268.645-2.705,3.053-12.617,15.606-63.2,17.022-64.034,14.117-10.715,44.454,7.545,64.193,0,0,0,2.774,3.434,16.628-7.427-5,1.341-15.391,7.892-35.119,3.845-25.878-5.305-56.8-29.439-64.235-9.721C298.527,324.17,300.693,377.849,300.736,378.822Z",
    transform: "translate(-26.671 -26.368)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8113",
    "data-name": "Path 8113",
    d: "M296.346,389.711l2.4,17.054,5.535-.854,5.61-16.763Z",
    transform: "translate(-26.31 -34.55)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8114",
    "data-name": "Path 8114",
    d: "M296.24,406.491s-26.9,18.293-22.965,35.1l42.741-29.055s-2.869-11.731-12.713-10.25c0,0-.568,4.127-7.062,4.21",
    transform: "translate(-24.227 -35.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8115",
    "data-name": "Path 8115",
    d: "M296.24,406.491s-26.9,18.293-22.965,35.1l42.741-29.055s-2.869-11.731-12.713-10.25C303.3,402.281,302.734,406.408,296.24,406.491Z",
    transform: "translate(-24.227 -35.704)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8116",
    "data-name": "Path 8116",
    d: "M315.221,411.777l-29.4,19.991a22.124,22.124,0,0,0-7.688-7.148c-.3-.169-.533.318-.232.487a21.51,21.51,0,0,1,7.478,6.961l-12.785,8.69a.269.269,0,0,0,.3.446l12.78-8.687c.213.341.457.656.658,1.012.168.3.613,0,.444-.305-.2-.352-.447-.667-.661-1.007l29.414-19.994a.271.271,0,0,0-.3-.448",
    transform: "translate(-24.191 -36.554)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8117",
    "data-name": "Path 8117",
    d: "M290.066,411.783a.227.227,0,0,0,.057-.25c-1.1-3.08-10.46-8.837-12.293-3.688-.624,1.756.79,3.751,2.246,4.779.261,1.59,2.331,2.573,3.766,2.671a5.235,5.235,0,0,0,3.145-.873.206.206,0,0,0,.183.148,6.87,6.87,0,0,1,5.271,3.31c.178.3.623-.006.443-.3a7.351,7.351,0,0,0-5.4-3.487,16.333,16.333,0,0,0,2.063-1.812c.025-.006.054-.015.081-.019s.02-.022.032-.027a.334.334,0,0,0,.1.042c.015,0,.023.017.046.022a7.021,7.021,0,0,1,5.889,3.492c.175.3.623-.005.447-.3a7.572,7.572,0,0,0-6.075-3.7m-11.585-2.133c-1.18-4.2,3.987-3.245,6.06-2.2,1.694.855,3.834,1.93,4.8,3.677a7.786,7.786,0,0,0-4.993-1.82c-1.618-.069-4.026.848-4.271,2.7a4.1,4.1,0,0,1-1.592-2.356m10.738,2.158c-2.489.642-6.2,1.694-8.612.513a2.348,2.348,0,0,1,1.328-1.914,4.756,4.756,0,0,1,3.4-.454,6.312,6.312,0,0,1,3.888,1.854m-3.517,2.675c-1.514.552-3.871.266-4.8-1.253-.041-.067-.03-.122-.06-.184,2.21,1.024,5.235.191,7.662-.486a8.263,8.263,0,0,1-2.8,1.923",
    transform: "translate(-24.653 -36.027)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8118",
    "data-name": "Path 8118",
    d: "M292.118,394.879a3.148,3.148,0,0,1-1.358-4.413,7.943,7.943,0,0,1-.026-3.138c.39-.953,20.98-.95,21.847,1.935s-1.186,3.526-1.186,3.526,2.3,2.183-.354,2.611-12.288,2.049-18.924-.519",
    transform: "translate(-25.775 -34.337)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8119",
    "data-name": "Path 8119",
    d: "M279.783,230.406c1.818,2.242,10.73,6.279,13.171,5.911,16.375-2.384,25.228-16.5,31.671-23.166a34.016,34.016,0,0,0,2.98-3.493,37.469,37.469,0,0,0,7.036-17.255,40.66,40.66,0,0,0,.4-8.968s9.138-45.294-.285-40.952c-9.478,4.4-21.285,23.9-29.913,38.8-.254.427-.482.851-.737,1.25-.54.937-1.051,1.843-1.561,2.7-1.332,2.325-2.582,4.512-3.718,6.386-2.44,4.143-8.647,13.638-8.647,13.638s-17.946,15.934-10.4,25.157",
    transform: "translate(-24.675 -12.624)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8120",
    "data-name": "Path 8120",
    d: "M337.391,183.438a43.78,43.78,0,0,1-9.93,30.4c-6.375,7.169-28.161-27.781-21.908-36.564,9.525-13.376,22.235-30.472,31.553-34.79,9.423-4.34.285,40.954.285,40.954",
    transform: "translate(-27.029 -12.624)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8121",
    "data-name": "Path 8121",
    d: "M340.486,145.368s-7.223,13.777-8.643,23.355-4.867,23.289-2.428,33.147c1.941,7.832,2.437,9.3,2.5,9.3a.027.027,0,0,0,.016-.005l5.577-8.278s5.976-9.2,5.055-11.385-2.078-46.137-2.078-46.137",
    transform: "translate(-29.171 -12.906)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M323.366,239.613c.426,1.333,18.971,11.956,29.317,15.844,17.942,6.74,48.29,11.984,56.064,10.51,3.179-.6,5.221-1.45,5.707-2.469,1.5-3.237-3.679-34.726-3.052-55.671.113-4.057.2-8.173.2-12.2.114-21.058-1.36-40.782-6.131-44.444-1.078-.851-2.325-1.729-3.717-2.666a69.889,69.889,0,0,0-7.208-4.316,67.691,67.691,0,0,0-14.845-5.731,61.576,61.576,0,0,0-29.626-.455.027.027,0,0,1-.028.027,60.065,60.065,0,0,0-8.173,2.442c-.654.228-1.306.482-1.987.737-9.31,3.747-7.976,24.009-6.471,41.009.681,7.887,1.391,15.068,1.105,19.553a39.026,39.026,0,0,1-.566,4.484c-2.1,12.516-9.027,24.237-10.587,33.346",
    transform: "translate(-28.709 -12.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8123",
    "data-name": "Path 8123",
    d: "M318.993,240.088c.427,1.333,24.832,12.772,38.668,18.447,17.735,7.275,42.908,8.908,50.682,7.434,3.179-.6,5.221-1.45,5.707-2.469,1.5-3.238-3.679-34.726-3.052-55.671.113-4.057.2-8.173.2-12.2.114-21.057-1.361-40.782-6.131-44.443-1.078-.851-2.325-1.73-3.717-2.666a69.883,69.883,0,0,0-7.208-4.316,67.692,67.692,0,0,0-14.845-5.732,61.588,61.588,0,0,0-29.626-.454.027.027,0,0,1-.028.027,60.063,60.063,0,0,0-8.173,2.442c-.654.227-1.306.482-1.987.737-9.31,3.747-7.977,24.008-6.471,41.009.682,7.888-16.061,56.917-14.015,57.857",
    transform: "translate(-28.306 -12.112)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8124",
    "data-name": "Path 8124",
    d: "M361.55,126.266v9.1s-2.153,3.946,0,4.376c4.727.949,11.557-4.371,11.557-4.371v-13.9Z",
    transform: "translate(-32.014 -10.785)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8125",
    "data-name": "Path 8125",
    d: "M352.069,105.69s-1.222,9.545.384,17.5c1.14,5.645,13.471,9.375,18.911-1s-.792-21.233-.792-21.233Z",
    transform: "translate(-31.218 -8.963)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8126",
    "data-name": "Path 8126",
    d: "M406.584,227.729c1.136,8.686,4.869,30.952,7.676,39.58,3.179-.6,5.222-1.45,5.707-2.469,1.5-3.237-3.678-34.727-3.051-55.671.113-4.057.2-8.173.2-12.2a75.527,75.527,0,0,0-5.987-10.869c-6.7-10.33-6.512-37.814-10.905-34.242-15.573,12.677-18.962,38.26-9.456,52,6.5,9.337,14.231,11.761,15.82,23.878",
    transform: "translate(-34.223 -13.454)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M343.751,104.932c5.578,4.472,15.124,1.785,22.188-.531.109.764.335,1.538.447,2.151.495,2.727.147,6.381,1.979,8.673a3.48,3.48,0,0,0,4.941.676,2.964,2.964,0,0,0,1.151-2.751c1.576-5.459-.839-13.8-5.158-16.825-2.735-1.912-5.774-1.709-8.934-1.3a19.189,19.189,0,0,1-7.247.043,13.671,13.671,0,0,0-4.364-.716c-6.035.464-10.73,5.992-5,10.583",
    transform: "translate(-30.289 -8.375)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M338.457,249.946l43.191,2.613-41.339,11.59Z",
    transform: "translate(-30.049 -22.191)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M337.825,249.358l46.768,2.829L340.387,264.58l-.557.157Z",
    transform: "translate(-29.993 -22.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8130",
    "data-name": "Path 8130",
    d: "M337.825,249.358l46.768,2.829L340.387,264.58l-.557.157Z",
    transform: "translate(-29.993 -22.139)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8807",
    "data-name": "Group 8807",
    transform: "translate(310.246 230.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8806",
    "data-name": "Group 8806",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2927",
    "data-name": "Rectangle 2927",
    width: 41.581,
    height: 16.805,
    fill: "url(#linear-gradient)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8809",
    "data-name": "Group 8809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8808",
    "data-name": "Group 8808",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8132",
    "data-name": "Path 8132",
    d: "M242.389,259.6l89.39,5.4-.015,5.214-89.355-5.972Z",
    transform: "translate(-21.52 -23.048)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    d: "M242.942,260.189l.016,3.644,88.356,5.9.01-4.207Z",
    transform: "translate(-21.569 -23.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8134",
    "data-name": "Path 8134",
    d: "M242.942,260.189l.016,3.644,88.356,5.9.01-4.207Z",
    transform: "translate(-21.569 -23.1)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8811",
    "data-name": "Group 8811",
    transform: "translate(214.126 185.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8810",
    "data-name": "Group 8810",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2929",
    "data-name": "Rectangle 2929",
    width: 96.38,
    height: 56.605,
    transform: "translate(-0.247 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8813",
    "data-name": "Group 8813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8812",
    "data-name": "Group 8812",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8136",
    "data-name": "Path 8136",
    d: "M347.935,235.779a18.75,18.75,0,0,1,7.161-.77,8.382,8.382,0,0,1,.889-.144,9.28,9.28,0,0,1-.485-.8c-.8-1.768-.925-4.739,1.253-5.623,2.3-.93,3.767,2.007,4.947,3.425a17.012,17.012,0,0,0,4.884,4.3,28.548,28.548,0,0,0,6.161,1.319c.762.134,1.779.222,2.714.474.068.005,31.493,2.549,37.75-7.9,1.136-1.9-2.192-23.63-8.038-29.25-2.613-2.5-5.365-4.967-7.749-7.04a33.5,33.5,0,0,1-11.265-19.381,34.667,34.667,0,0,1,1.533-18.192,10.43,10.43,0,0,1,16.373-4.316c10.587,8.627,27.649,30.757,28.076,31.3C447.261,202.96,452.4,229.321,440.3,246.3c-12.062,16.919-65.595,1.017-65.595,1.017a16.049,16.049,0,0,1-3.9,1.142,13.116,13.116,0,0,1-7.311.441,9.262,9.262,0,0,1-1.5-.6,12.481,12.481,0,0,1-6.811.818,1.522,1.522,0,0,1-1.167-2.109,2.835,2.835,0,0,1-1.261-.713,2.136,2.136,0,0,1-.581-1.468,5.026,5.026,0,0,1-1.2-.888,4.111,4.111,0,0,1-1-4.328,19.945,19.945,0,0,0-5.865,4.666,1.63,1.63,0,0,1-2.738-.523c-1.633-3.573,3.792-7.043,6.571-7.977",
    transform: "translate(-30.28 -13.274)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    "data-name": "Path 8137",
    d: "M409.412,205.348c-2.408-2.3-17.571-17.161-19.894-31.933-1.056-6.721,1.026-22.943,9.39-24.88,13.4-3.1,31.306,16.35,43.658,31.032-5.67,12.788-18.1,21.731-33.155,25.78",
    transform: "translate(-34.56 -13.158)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8138",
    "data-name": "Path 8138",
    d: "M276.4,267.122a.448.448,0,0,1-.213-.338,2.478,2.478,0,0,1-1.649.945c-.831.008-1.3-.693-1.663-1.216a.417.417,0,0,1-.033-.08c-.832,1.147-1.971,2.1-3.323,1.826-1.28-.252-1.555-1.28-1.442-2.448a7.147,7.147,0,0,1-1.105,1.053c-1.557,1.173-3.143-.19-3.65-1.491a.484.484,0,0,1,.106-.527.505.505,0,0,1,.014-.144,15.361,15.361,0,0,1,1.538-3.572,6.532,6.532,0,0,1,1.993-2.481c1.627-.892,2.358.9,2.633,2.138.449-1.234,1.237-2.3,2.908-1.667a2.863,2.863,0,0,1,1.91,2.14,4,4,0,0,1,1.322-1.389c1.407-.857,2.4.645,2.652,1.67a3.671,3.671,0,0,1,.042,1.452,1.009,1.009,0,0,1,.335-.127c1.031-.2,1.688,1.011,1.818,1.7.388,2.068-2.081,3.708-4.191,2.55",
    transform: "translate(-23.375 -22.942)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8139",
    "data-name": "Path 8139",
    d: "M136.782,317.813a17.77,17.77,0,0,0,10.105-3.331,86.266,86.266,0,0,1-1.5,18.565c-3.97,6.4-14.988,18.175-14.243,18.108a35.685,35.685,0,0,0,8.842-2.061,65.884,65.884,0,0,1-6.736,11.013c-5.344,7.128-12.959,12.828-15.852,21.528a.548.548,0,0,1-.334.381.63.63,0,0,1-1.043.461c-14.377-13.651-16.947-34.389-19.057-53.087-.1-.888-.2-1.76-.282-2.649a57.671,57.671,0,0,0,13.251,10.342c.7.379-9-15.14-13.749-22.29a41.956,41.956,0,0,1,2.475-13.279c3.364-9.014,9.133-17.449,14.733-25.211.224-.32.485-.628.71-.947a43,43,0,0,0,6.187,11.207c.46.6-1.02-11.349-1.93-16.806,1.406-1.745,2.811-3.489,4.273-5.176,1.919-2.261,4.283-6.092,7.726-5.581,3.341.473,10.951,14.151,11.916,18.065.417,1.67.79,3.378,1.131,5.089.164.734.3,1.487.431,2.224A205.908,205.908,0,0,1,146.4,305.2c-.237.37-.473.739-.743,1.1-2.793,3.8-9.559,11.511-8.872,11.516",
    transform: "translate(-8.539 -22.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8140",
    "data-name": "Path 8140",
    d: "M136.782,317.813a17.77,17.77,0,0,0,10.105-3.331,86.266,86.266,0,0,1-1.5,18.565c-3.97,6.4-14.988,18.175-14.243,18.108a35.685,35.685,0,0,0,8.842-2.061,65.884,65.884,0,0,1-6.736,11.013c-5.344,7.128-12.959,12.828-15.852,21.528a.548.548,0,0,1-.334.381.63.63,0,0,1-1.043.461c-14.377-13.651-16.947-34.389-19.057-53.087-.1-.888-.2-1.76-.282-2.649a57.671,57.671,0,0,0,13.251,10.342c.7.379-9-15.14-13.749-22.29a41.956,41.956,0,0,1,2.475-13.279c3.364-9.014,9.133-17.449,14.733-25.211.224-.32.485-.628.71-.947a43,43,0,0,0,6.187,11.207c.46.6-1.02-11.349-1.93-16.806,1.406-1.745,2.811-3.489,4.273-5.176,1.919-2.261,4.283-6.092,7.726-5.581,3.341.473,10.951,14.151,11.916,18.065.417,1.67.79,3.378,1.131,5.089.164.734.3,1.487.431,2.224A205.908,205.908,0,0,1,146.4,305.2c-.237.37-.473.739-.743,1.1C142.861,310.1,136.1,317.809,136.782,317.813Z",
    transform: "translate(-8.539 -22.99)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8141",
    "data-name": "Path 8141",
    d: "M125.017,312.661c7.094-1.072,12.513-5.551,17.724-10.176.776-.689-.188-2-.972-1.3-4.88,4.332-9.965,8.66-16.581,9.787,1.509-10.56,3.267-21.087,5.339-31.561.2-1.028-1.4-1.276-1.6-.253Q124.8,299.978,122.2,321.03a69.553,69.553,0,0,1-9.389-18.87c-.32-.994-1.828-.387-1.509.605a71.024,71.024,0,0,0,10.074,19.929.722.722,0,0,0,.588.321c-.374,3.067-.714,6.139-1.042,9.212a43.739,43.739,0,0,1-6.968-12.194c-.364-.979-1.873-.376-1.508.605a45.092,45.092,0,0,0,7.92,13.52.82.82,0,0,0,.334.233q-1.561,15.168-2.362,30.406a.806.806,0,0,0-.1.348q-.325,5.578-.388,11.139-.119,3.633-.2,7.266a.645.645,0,0,0,.234.549c.419,22.883,3.809,45.517,8.625,67.914.525-.129,1.052-.247,1.578-.37-5.439-25.31-9.057-50.924-8.582-76.864q.145-4.1.345-8.208a.762.762,0,0,0,.721-.091,27.023,27.023,0,0,0,7.431-7.6c.567-.87-.7-1.891-1.27-1.012a25.843,25.843,0,0,1-6.8,7.06q1.356-26.232,5.014-52.265c.024,0,.042.007.067,0",
    transform: "translate(-9.877 -24.726)",
    fill: "#040a2e"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8815",
    "data-name": "Group 8815",
    transform: "translate(42.211 288.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8814",
    "data-name": "Group 8814",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2931",
    "data-name": "Rectangle 2931",
    width: 61.518,
    height: 89.043,
    transform: "translate(-0.29 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8817",
    "data-name": "Group 8817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8816",
    "data-name": "Group 8816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8143",
    "data-name": "Path 8143",
    d: "M111.916,460.025c-2.415-18.411-6.111-36.532-12.4-53.864a.494.494,0,0,0,.039-.487q-1.118-2.706-2.277-5.394-1.674-4.156-3.567-8.243a.624.624,0,0,0-.183-.23q-5.1-11.182-10.843-22.069a.729.729,0,0,0,.216-.284,35.642,35.642,0,0,0,2.8-12.762c.026-.858-1.432-.815-1.458.042a34.429,34.429,0,0,1-2.38,11.451q-1.756-3.3-3.563-6.578a.686.686,0,0,0,.407-.434,55.011,55.011,0,0,0,2.772-18.286c-.017-.851-1.475-.811-1.458.042a53.734,53.734,0,0,1-2.5,17.265q-8.349-14.942-17.884-29.252c-.47-.7-1.763.012-1.292.718q7.207,10.782,13.71,21.959c-5.951,1.329-11.531-.252-16.939-1.9a.687.687,0,0,0-.448,1.3c5.773,1.761,11.683,3.346,18.023,1.82.024-.005.036-.019.057-.026Q83.405,373.151,92.2,392.429a22.263,22.263,0,0,1-7.833-3.07c-.74-.472-1.52.711-.785,1.178a23.309,23.309,0,0,0,8.527,3.27.773.773,0,0,0,.639-.169q1.361,3.014,2.677,6.05c7.941,19.335,12.31,39.771,15.041,60.577.483-.079.965-.164,1.449-.241",
    transform: "translate(-4.813 -29.356)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8144",
    "data-name": "Path 8144",
    d: "M59.561,345.518a37.263,37.263,0,0,1-12.639-4.94c.073.605.179,1.216.28,1.813a39.075,39.075,0,0,0,11.9,4.422c.911.169,1.354-1.122.457-1.3",
    transform: "translate(-4.166 -30.237)",
    fill: "#040a2e"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8819",
    "data-name": "Group 8819",
    transform: "translate(117.109 316.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8818",
    "data-name": "Group 8818",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2933",
    "data-name": "Rectangle 2933",
    width: 76.214,
    height: 65.912,
    transform: "translate(-0.79)",
    fill: "url(#linear-gradient-4)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8821",
    "data-name": "Group 8821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8820",
    "data-name": "Group 8820",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8146",
    "data-name": "Path 8146",
    d: "M152.305,374.738c-11.493,11.342-15.062,32.18-15.8,38.1a26.86,26.86,0,0,0-2.365,7.694c-1.369,9.351-.966,19.219-.734,28.64.077,3.1.214,6.2.378,9.292.533-.1,1.064-.2,1.6-.3-.1-1.954-.194-3.907-.261-5.863-.287-8.435-.278-16.892.109-25.324.2-4.357.6-8.738,2.294-12.777a1.786,1.786,0,0,0,.511-.476c7.152-9.943,14.3-20.35,22.584-29.369,7.034-7.65,16.316-11.2,25.821-14.722,4.3-1.588,17.824-4.421,17.911-10.271-18.026,2.1-38.816,2.317-52.045,15.373",
    transform: "translate(-11.823 -31.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8147",
    "data-name": "Path 8147",
    d: "M152.305,374.738c-11.493,11.342-15.062,32.18-15.8,38.1a26.86,26.86,0,0,0-2.365,7.694c-1.369,9.351-.966,19.219-.734,28.64.077,3.1.214,6.2.378,9.292.533-.1,1.064-.2,1.6-.3-.1-1.954-.194-3.907-.261-5.863-.287-8.435-.278-16.892.109-25.324.2-4.357.6-8.738,2.294-12.777a1.786,1.786,0,0,0,.511-.476c7.152-9.943,14.3-20.35,22.584-29.369,7.034-7.65,16.316-11.2,25.821-14.722,4.3-1.588,17.824-4.421,17.911-10.271C186.325,361.468,165.534,361.682,152.305,374.738Z",
    transform: "translate(-11.823 -31.905)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M153.446,368.857A37.5,37.5,0,0,1,153.2,355.8q-.656.365-1.275.73a38.39,38.39,0,0,0,.359,12.587c.147.753,1.3.48,1.16-.26",
    transform: "translate(-13.457 -31.589)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M148.527,371.553a49.408,49.408,0,0,1-1.678-11.634c-.391.281-.771.584-1.15.889a50.141,50.141,0,0,0,1.668,11.017c.2.731,1.355.47,1.16-.272",
    transform: "translate(-12.936 -31.955)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    "data-name": "Path 8150",
    d: "M161.681,456.839a42.1,42.1,0,0,1-17.451,34.177h-49.5A42.207,42.207,0,0,1,78.3,447.64a41.2,41.2,0,0,1,2.323-7.279h77.72a41.3,41.3,0,0,1,2.33,7.279,42.021,42.021,0,0,1,1.013,9.2",
    transform: "translate(-6.861 -39.096)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    "data-name": "Path 8151",
    d: "M163.38,456.839a42.1,42.1,0,0,1-17.451,34.177h-49.5c64.68,3.212,63.612-50.655,63.612-50.655a41.3,41.3,0,0,1,2.33,7.279,42.02,42.02,0,0,1,1.013,9.2",
    transform: "translate(-8.561 -39.096)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    "data-name": "Path 8152",
    d: "M118.122,129.713v-14.77h-5.275v-3.008h14.128v3.008h-5.262v14.77Z",
    transform: "translate(-10.019 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M130.906,129.713V111.935h7.555a12.917,12.917,0,0,1,4.141.479,4.086,4.086,0,0,1,2.068,1.7,5.131,5.131,0,0,1,.776,2.8,4.749,4.749,0,0,1-1.176,3.3,5.654,5.654,0,0,1-3.517,1.644,8.4,8.4,0,0,1,1.923,1.491,20.325,20.325,0,0,1,2.043,2.887l2.171,3.468H142.6l-2.6-3.869a24.886,24.886,0,0,0-1.893-2.612,2.731,2.731,0,0,0-1.079-.74,5.926,5.926,0,0,0-1.807-.2H134.5v7.422Zm3.589-10.259h2.656a13.645,13.645,0,0,0,3.226-.219,1.929,1.929,0,0,0,1.006-.751,2.319,2.319,0,0,0,.364-1.334,2.131,2.131,0,0,0-.479-1.45,2.2,2.2,0,0,0-1.352-.7q-.436-.062-2.62-.06h-2.8Z",
    transform: "translate(-11.622 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M166.431,129.713h-3.9l-1.552-4.039h-7.107l-1.467,4.039h-3.808l6.923-17.778h3.8Zm-6.609-7.034-2.449-6.6-2.4,6.6Z",
    transform: "translate(-13.192 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M170.3,129.713V111.935h3.493l7.276,11.872V111.935H184.4v17.778h-3.6l-7.167-11.593v11.593Z",
    transform: "translate(-15.12 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M188.944,123.9l3.493-.34a4.257,4.257,0,0,0,1.278,2.583,3.868,3.868,0,0,0,2.6.825,4,4,0,0,0,2.613-.734,2.186,2.186,0,0,0,.88-1.716,1.621,1.621,0,0,0-.37-1.073,2.956,2.956,0,0,0-1.292-.77q-.63-.219-2.874-.776a9.738,9.738,0,0,1-4.05-1.759,4.624,4.624,0,0,1-1.637-3.577,4.568,4.568,0,0,1,.771-2.54,4.812,4.812,0,0,1,2.219-1.8,8.9,8.9,0,0,1,3.5-.619,7.5,7.5,0,0,1,5.038,1.468,5.176,5.176,0,0,1,1.776,3.916l-3.589.158a3.047,3.047,0,0,0-.988-1.97,3.615,3.615,0,0,0-2.274-.6,4.1,4.1,0,0,0-2.449.643,1.294,1.294,0,0,0-.57,1.1,1.367,1.367,0,0,0,.534,1.08,9.434,9.434,0,0,0,3.3,1.188,17.428,17.428,0,0,1,3.874,1.279,4.988,4.988,0,0,1,1.965,1.807,5.288,5.288,0,0,1,.71,2.832,5.234,5.234,0,0,1-.849,2.861,5.086,5.086,0,0,1-2.4,1.983,10.066,10.066,0,0,1-3.869.649,7.7,7.7,0,0,1-5.178-1.558,6.776,6.776,0,0,1-2.159-4.541",
    transform: "translate(-16.775 -9.908)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8157",
    "data-name": "Path 8157",
    d: "M223.977,129.713h-3.9l-1.553-4.039h-7.106l-1.468,4.039h-3.807l6.923-17.778h3.8Zm-6.609-7.034-2.45-6.6-2.4,6.6Z",
    transform: "translate(-18.302 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8158",
    "data-name": "Path 8158",
    d: "M239.117,123.147l3.481,1.1a7.809,7.809,0,0,1-2.662,4.323,8.375,8.375,0,0,1-10.545-1.006,9.258,9.258,0,0,1-2.28-6.615,9.722,9.722,0,0,1,2.292-6.894,7.859,7.859,0,0,1,6.028-2.456,7.4,7.4,0,0,1,5.3,1.928,7,7,0,0,1,1.819,3.275l-3.553.848a3.674,3.674,0,0,0-3.747-2.983,4.045,4.045,0,0,0-3.208,1.419q-1.231,1.42-1.231,4.6,0,3.372,1.213,4.8a3.937,3.937,0,0,0,3.153,1.432,3.6,3.6,0,0,0,2.462-.91,5.276,5.276,0,0,0,1.479-2.861",
    transform: "translate(-20.164 -9.908)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M251.364,129.713v-14.77h-5.275v-3.008h14.128v3.008h-5.262v14.77Z",
    transform: "translate(-21.848 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2934",
    "data-name": "Rectangle 2934",
    width: 3.589,
    height: 17.778,
    transform: "translate(240.576 101.997)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M270.91,120.9a11.317,11.317,0,0,1,.812-4.56,8.366,8.366,0,0,1,1.657-2.437,6.9,6.9,0,0,1,2.3-1.6,9.758,9.758,0,0,1,3.833-.7,8.346,8.346,0,0,1,6.288,2.438,10.894,10.894,0,0,1,.018,13.515,9.348,9.348,0,0,1-12.564.012,9.178,9.178,0,0,1-2.341-6.664m3.7-.121a6.663,6.663,0,0,0,1.4,4.578,4.8,4.8,0,0,0,7.064.013,6.8,6.8,0,0,0,1.377-4.639,6.686,6.686,0,0,0-1.34-4.56,4.966,4.966,0,0,0-7.138.018,6.721,6.721,0,0,0-1.358,4.59",
    transform: "translate(-24.052 -9.908)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8161",
    "data-name": "Path 8161",
    d: "M292.949,129.713V111.935h3.493l7.275,11.872V111.935h3.336v17.778h-3.6l-7.167-11.593v11.593Z",
    transform: "translate(-26.009 -9.938)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2935",
    "data-name": "Rectangle 2935",
    width: 179.292,
    height: 16.294,
    transform: "translate(102.781 129.936)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2936",
    "data-name": "Rectangle 2936",
    width: 179.292,
    height: 16.294,
    transform: "translate(102.781 129.936)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2937",
    "data-name": "Rectangle 2937",
    width: 115.624,
    height: 16.294,
    transform: "translate(102.78 129.936)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8162",
    "data-name": "Path 8162",
    d: "M168.955,198.082V183.655h2.937v11.976h7.3v2.45Z",
    transform: "translate(-15 -16.305)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8163",
    "data-name": "Path 8163",
    d: "M181.76,193.02a5.7,5.7,0,0,1,.685-2.689,4.7,4.7,0,0,1,1.939-1.985,5.758,5.758,0,0,1,2.8-.684,5.259,5.259,0,0,1,3.919,1.553,5.365,5.365,0,0,1,1.528,3.925,5.429,5.429,0,0,1-1.543,3.964,5.217,5.217,0,0,1-3.885,1.573,6.122,6.122,0,0,1-2.764-.655,4.492,4.492,0,0,1-2-1.92,6.4,6.4,0,0,1-.685-3.081m2.858.149a3.489,3.489,0,0,0,.744,2.4,2.432,2.432,0,0,0,3.666,0,3.538,3.538,0,0,0,.739-2.421,3.474,3.474,0,0,0-.739-2.381,2.433,2.433,0,0,0-3.666,0,3.489,3.489,0,0,0-.744,2.4",
    transform: "translate(-16.137 -16.661)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8164",
    "data-name": "Path 8164",
    d: "M198.1,191.115l-2.53-.456a3.946,3.946,0,0,1,1.469-2.263,5.375,5.375,0,0,1,3.1-.734,6.671,6.671,0,0,1,2.778.442,2.77,2.77,0,0,1,1.285,1.121,5.754,5.754,0,0,1,.372,2.5l-.029,3.254a11.393,11.393,0,0,0,.133,2.048,6.013,6.013,0,0,0,.5,1.414h-2.758q-.111-.277-.268-.823c-.046-.166-.08-.275-.1-.328a5.034,5.034,0,0,1-1.528,1.042,4.383,4.383,0,0,1-1.737.348,3.592,3.592,0,0,1-2.564-.883,2.938,2.938,0,0,1-.938-2.233,3,3,0,0,1,.426-1.592,2.782,2.782,0,0,1,1.2-1.072,9.338,9.338,0,0,1,2.218-.65,15.152,15.152,0,0,0,2.708-.685v-.277a1.445,1.445,0,0,0-.4-1.146,2.384,2.384,0,0,0-1.5-.343,1.99,1.99,0,0,0-1.161.293,2.038,2.038,0,0,0-.674,1.026m3.731,2.263a17.179,17.179,0,0,1-1.7.426,5.118,5.118,0,0,0-1.518.487,1.163,1.163,0,0,0-.546.982,1.368,1.368,0,0,0,.436,1.011,1.522,1.522,0,0,0,1.112.426,2.414,2.414,0,0,0,1.439-.5,1.745,1.745,0,0,0,.664-.923,5.488,5.488,0,0,0,.109-1.359Z",
    transform: "translate(-17.338 -16.661)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8165",
    "data-name": "Path 8165",
    d: "M218.1,198.07h-2.59v-1.548a4.187,4.187,0,0,1-1.524,1.345,3.906,3.906,0,0,1-1.771.442,4.015,4.015,0,0,1-3.11-1.463,5.956,5.956,0,0,1-1.295-4.083,5.888,5.888,0,0,1,1.259-4.073,4.111,4.111,0,0,1,3.186-1.394,3.942,3.942,0,0,1,3.055,1.469v-5.239H218.1Zm-7.442-5.5a4.813,4.813,0,0,0,.467,2.44,2.106,2.106,0,0,0,1.885,1.092,2.05,2.05,0,0,0,1.637-.818,3.777,3.777,0,0,0,.674-2.446,4.133,4.133,0,0,0-.654-2.614,2.071,2.071,0,0,0-1.677-.8,2.1,2.1,0,0,0-1.662.789,3.563,3.563,0,0,0-.67,2.356",
    transform: "translate(-18.45 -16.294)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M222.113,183.525H224.9v2.58h-2.788Zm0,4.008H224.9V198.07h-2.788Z",
    transform: "translate(-19.72 -16.294)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M237.891,198.437H235.1v-5.378a8.292,8.292,0,0,0-.179-2.207,1.541,1.541,0,0,0-.58-.779,1.663,1.663,0,0,0-.968-.278,2.233,2.233,0,0,0-1.3.4,2,2,0,0,0-.788,1.052,9.1,9.1,0,0,0-.213,2.421v4.772h-2.788V187.9h2.59v1.548a4.317,4.317,0,0,1,5.159-1.453,2.814,2.814,0,0,1,1.155.848,3.061,3.061,0,0,1,.546,1.171,8.678,8.678,0,0,1,.154,1.875Z",
    transform: "translate(-20.268 -16.661)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M241.612,199.132l3.185.387a1.087,1.087,0,0,0,.367.764,2.1,2.1,0,0,0,1.25.3,3.237,3.237,0,0,0,1.637-.328,1.348,1.348,0,0,0,.556-.7,4.211,4.211,0,0,0,.129-1.28v-1.537a3.774,3.774,0,0,1-3.156,1.706,3.883,3.883,0,0,1-3.363-1.8,6.107,6.107,0,0,1-.972-3.533,5.807,5.807,0,0,1,1.275-4.048,4.115,4.115,0,0,1,3.17-1.4,3.86,3.86,0,0,1,3.225,1.717V187.9h2.61v9.456a9.417,9.417,0,0,1-.308,2.787,3.456,3.456,0,0,1-.863,1.449,3.821,3.821,0,0,1-1.483.824,7.8,7.8,0,0,1-2.346.3,6.08,6.08,0,0,1-3.8-.917,2.881,2.881,0,0,1-1.121-2.327c0-.093,0-.205.01-.337m2.49-6.182a3.8,3.8,0,0,0,.65,2.456,2.01,2.01,0,0,0,1.6.779,2.213,2.213,0,0,0,1.726-.8,3.478,3.478,0,0,0,.7-2.366,3.684,3.684,0,0,0-.674-2.43,2.144,2.144,0,0,0-1.707-.794,2.061,2.061,0,0,0-1.652.778,3.655,3.655,0,0,0-.65,2.376",
    transform: "translate(-21.418 -16.661)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2938",
    "data-name": "Rectangle 2938",
    width: 2.788,
    height: 2.788,
    transform: "translate(232.863 178.988)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2939",
    "data-name": "Rectangle 2939",
    width: 2.788,
    height: 2.788,
    transform: "translate(238.509 178.988)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2940",
    "data-name": "Rectangle 2940",
    width: 2.788,
    height: 2.788,
    transform: "translate(244.155 178.988)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M536.922,271.989c3.829-9.114.269-21.24-9.33-29.314-9.534-8.019-21.985-9.483-30.308-4.278l-.671-.567-3.566,4.242c-7.74,9.2-4.824,24.393,6.515,33.93s26.805,9.807,34.546.605l3.543-4Z",
    transform: "translate(-43.389 -20.894)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M536.922,271.989c3.829-9.114.269-21.24-9.33-29.314-9.534-8.019-21.985-9.483-30.308-4.278l-.671-.567-3.566,4.242c-7.74,9.2-4.824,24.393,6.515,33.93s26.805,9.807,34.546.605l3.543-4Z",
    transform: "translate(-43.389 -20.894)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M531.506,238.02c11.339,9.536,14.231,24.97,6.492,34.173s-23.182,8.69-34.522-.846-14.254-24.729-6.515-33.931,23.207-8.933,34.545.6",
    transform: "translate(-43.737 -20.481)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8172",
    "data-name": "Path 8172",
    d: "M529.447,241.423c9.312,7.834,11.689,20.51,5.331,28.066s-19.042,7.14-28.354-.693-11.708-20.31-5.351-27.869,19.061-7.338,28.373.5",
    transform: "translate(-44.171 -20.899)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8173",
    "data-name": "Path 8173",
    d: "M521.681,275.117a25.328,25.328,0,0,1-15.422-6.172c-9.391-7.9-11.8-20.543-5.378-28.184a16.492,16.492,0,0,1,13.255-5.6A25.938,25.938,0,0,1,538.187,255.5c1.02,5.393-.138,10.4-3.259,14.115a14.838,14.838,0,0,1-2.149,2.085,16.9,16.9,0,0,1-11.1,3.421m7.6-33.545a24.468,24.468,0,0,0-15.155-5.968,16.046,16.046,0,0,0-12.9,5.445c-6.267,7.452-3.879,19.813,5.324,27.554a24.871,24.871,0,0,0,15.146,6.067c5.294.143,9.872-1.756,12.892-5.347s4.158-8.486,3.163-13.744a24.481,24.481,0,0,0-8.467-14.007",
    transform: "translate(-44.15 -20.878)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M528.782,253.591a5.41,5.41,0,0,0-1.372-1.133,5.325,5.325,0,0,0-1.525-.57,6.79,6.79,0,0,0-1.643-.111,11.673,11.673,0,0,0-1.715.246,16.4,16.4,0,0,0-1.753.464c-.593.184-1.181.375-1.775.571l-5.3-5.945a4.422,4.422,0,0,1,2.426-.707,5.618,5.618,0,0,1,2.574.787l2.13-1.9a7.779,7.779,0,0,0-2.323-1.322,6.7,6.7,0,0,0-2.324-.391,6.983,6.983,0,0,0-2.246.406,8.961,8.961,0,0,0-2.089,1.052l-1.7-1.914L508,245.048l1.7,1.908a8.628,8.628,0,0,0-1.319,2.13,7.475,7.475,0,0,0-.6,2.286,6.06,6.06,0,0,0,.211,2.257,4.378,4.378,0,0,0,.171.5,5.289,5.289,0,0,0,.951,1.5,5.9,5.9,0,0,0,.59.58,4.588,4.588,0,0,0,1.382.846,5.974,5.974,0,0,0,2.224.407,9.394,9.394,0,0,0,1.109-.064c.184-.024.375-.055.566-.084s.4-.077.6-.125c.04-.007.066-.015.107-.023.815-.2,1.64-.436,2.468-.7l4.456,5,.194.214.005.007.188.208.912,1.028a4.589,4.589,0,0,1-1.456.366,4.747,4.747,0,0,1-1.089-.03c-.12-.012-.24-.036-.358-.059l-.007.005c-.026,0-.056-.014-.081-.018-.081-.018-.167-.044-.253-.069a6.63,6.63,0,0,1-1.294-.484,7.806,7.806,0,0,1-1.494-.951l-2.269,2.017a10.386,10.386,0,0,0,2.238,1.42.171.171,0,0,0,.071.036c.059.035.121.056.174.084.006.007.013,0,.018.008a.363.363,0,0,1,.085.038,1.145,1.145,0,0,0,.2.074.33.33,0,0,0,.085.038,9.138,9.138,0,0,0,2.261.594c.2.029.406.046.6.056a1.81,1.81,0,0,0,.334.01,2.584,2.584,0,0,0,.333.01,7.772,7.772,0,0,0,1.369-.122,7.53,7.53,0,0,0,2.449-.871l2.7,3.031,2.152-1.919-2.647-2.978a10.922,10.922,0,0,0,1.485-2.119,7.468,7.468,0,0,0,.819-2.441,6.216,6.216,0,0,0-.147-2.561,6.053,6.053,0,0,0-1.417-2.5m-17.493-.029a2.843,2.843,0,0,1-.739-2.076,4.1,4.1,0,0,1,1.022-2.425l4.531,5.1a13.72,13.72,0,0,1-1.442.323,5.415,5.415,0,0,1-1.3.061,3.473,3.473,0,0,1-1.13-.282,2.714,2.714,0,0,1-.939-.7m16.016,3.275a3.572,3.572,0,0,1,.17,1.389,4.594,4.594,0,0,1-.357,1.479,5.645,5.645,0,0,1-.918,1.448l-5.107-5.736a15.907,15.907,0,0,1,1.618-.42,7.43,7.43,0,0,1,1.533-.189,4.129,4.129,0,0,1,1.327.169,2.273,2.273,0,0,1,1.029.658,3.583,3.583,0,0,1,.706,1.2",
    transform: "translate(-45.08 -21.585)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M47.277,268.234c7.467-2.142,12.839-10.447,12.608-20.534-.231-10.018-5.918-18.6-13.418-21.246l-.015-.706-4.416-.128c-9.581-.281-17.126,9.151-16.851,21.066s8.267,21.8,17.847,22.082l4.259.234Z",
    transform: "translate(-2.235 -20.031)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8176",
    "data-name": "Path 8176",
    d: "M47.277,268.234c7.467-2.142,12.839-10.447,12.608-20.534-.231-10.018-5.918-18.6-13.418-21.246l-.015-.706-4.416-.128c-9.581-.281-17.126,9.151-16.851,21.066s8.267,21.8,17.847,22.082l4.259.234Z",
    transform: "translate(-2.235 -20.031)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8177",
    "data-name": "Path 8177",
    d: "M64.73,247.842c.276,11.916-7.426,21.452-17.008,21.173s-17.414-10.272-17.69-22.187S37.3,225.482,46.882,225.76s17.573,10.167,17.847,22.082",
    transform: "translate(-2.666 -20.043)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8178",
    "data-name": "Path 8178",
    d: "M61.934,248.137c.225,9.786-6.1,17.621-13.969,17.389S33.658,257.091,33.433,247.3s5.972-17.533,13.841-17.3,14.434,8.35,14.659,18.136",
    transform: "translate(-2.968 -20.42)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8179",
    "data-name": "Path 8179",
    d: "M37.677,260.09a21.45,21.45,0,0,1-4.439-12.807c-.227-9.87,6.061-17.71,14.015-17.478a13.906,13.906,0,0,1,10.335,5.555,21.12,21.12,0,0,1,4.506,12.766,19.284,19.284,0,0,1-3.987,12.564,12.476,12.476,0,0,1-10.156,5,11.881,11.881,0,0,1-2.379-.313,14.417,14.417,0,0,1-7.895-5.287m24.061-11.974a20.739,20.739,0,0,0-4.42-12.538,13.536,13.536,0,0,0-10.056-5.414c-7.759-.226-13.89,7.457-13.667,17.129a21.073,21.073,0,0,0,4.357,12.581,13.353,13.353,0,0,0,9.992,5.456,12.152,12.152,0,0,0,9.884-4.876,18.931,18.931,0,0,0,3.911-12.339",
    transform: "translate(-2.95 -20.402)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8180",
    "data-name": "Path 8180",
    d: "M55,253.422a4.4,4.4,0,0,0-.046-1.431,4.51,4.51,0,0,0-.463-1.247,5.867,5.867,0,0,0-.8-1.091,10,10,0,0,0-1.051-.959,14.09,14.09,0,0,0-1.2-.873c-.422-.282-.846-.557-1.277-.834l.762-6.309a3.763,3.763,0,0,1,1.7,1.175,4.786,4.786,0,0,1,.886,2.016l2.261.392a6.511,6.511,0,0,0-.434-2.125,5.757,5.757,0,0,0-.991-1.659,6.028,6.028,0,0,0-1.426-1.214,7.534,7.534,0,0,0-1.73-.791l.25-2.026-2.288-.4-.243,2.027a6.7,6.7,0,0,0-1.969.231,5.6,5.6,0,0,0-1.681.766,4.506,4.506,0,0,0-1.238,1.261,3.479,3.479,0,0,0-.209.359,4.1,4.1,0,0,0-.4,1.35,4.74,4.74,0,0,0-.036.663A3.791,3.791,0,0,0,43.6,244a5.142,5.142,0,0,0,.929,1.606,8.324,8.324,0,0,0,.622.667c.111.1.23.21.348.314s.259.216.393.318c.026.022.045.034.07.056.55.412,1.124.816,1.716,1.209l-.639,5.307-.026.23,0,.007-.025.222-.133,1.089a3.948,3.948,0,0,1-.987-.735,4.024,4.024,0,0,1-.556-.7,2.792,2.792,0,0,1-.154-.255l-.007,0c-.011-.017-.02-.042-.032-.06-.032-.06-.062-.128-.092-.194a5.569,5.569,0,0,1-.392-1.058,6.454,6.454,0,0,1-.22-1.418l-2.4-.422a8.576,8.576,0,0,0,.331,2.119.157.157,0,0,0,.016.064c.011.055.03.1.042.151,0,.007.005.009,0,.016a.3.3,0,0,1,.023.072.98.98,0,0,0,.061.164.363.363,0,0,0,.022.073,7.838,7.838,0,0,0,.837,1.722c.088.141.186.279.284.408a1.5,1.5,0,0,0,.169.214,2.238,2.238,0,0,0,.169.215,6.744,6.744,0,0,0,.795.8,6.4,6.4,0,0,0,1.812,1.109l-.39,3.215,2.282.4.385-3.157a8.561,8.561,0,0,0,2.05-.122,5.619,5.619,0,0,0,1.891-.7,4.519,4.519,0,0,0,2.2-3.518m-9.2-11.043a2.142,2.142,0,0,1,.851-1.5,3.108,3.108,0,0,1,1.988-.567l-.661,5.405a11.827,11.827,0,0,1-.954-.748,4.668,4.668,0,0,1-.723-.791,2.968,2.968,0,0,1-.427-.852,2.237,2.237,0,0,1-.075-.944m6.483,11.735a2.669,2.669,0,0,1-.74.8,3.485,3.485,0,0,1-1.073.513,4.375,4.375,0,0,1-1.35.145l.738-6.087a13.61,13.61,0,0,1,1.1.81,6.362,6.362,0,0,1,.92.872,3.527,3.527,0,0,1,.6.92,1.888,1.888,0,0,1,.149.979,2.757,2.757,0,0,1-.347,1.046",
    transform: "translate(-3.73 -20.957)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8181",
    "data-name": "Path 8181",
    d: "M455.949,102.153c-6.5-5.288-8.672-15.773-4.716-25.64,3.931-9.8,12.656-15.859,20.955-15.287l.275-.692,4.358,1.749c9.457,3.792,13.337,16.315,8.663,27.969s-16.131,18.024-25.589,14.23l-4.244-1.577Z",
    transform: "translate(-39.886 -5.374)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8182",
    "data-name": "Path 8182",
    d: "M455.949,102.153c-6.5-5.288-8.672-15.773-4.716-25.64,3.931-9.8,12.656-15.859,20.955-15.287l.275-.692,4.358,1.749c9.457,3.792,13.337,16.315,8.663,27.969s-16.131,18.024-25.589,14.23l-4.244-1.577Z",
    transform: "translate(-39.886 -5.374)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8183",
    "data-name": "Path 8183",
    d: "M446.452,74.659c-4.675,11.653-.682,24.346,8.776,28.14s20.8-2.748,25.474-14.4.795-24.175-8.662-27.969-20.915,2.578-25.588,14.23",
    transform: "translate(-39.463 -5.268)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8184",
    "data-name": "Path 8184",
    d: "M449.838,76.283c-3.838,9.571-.56,20,7.209,23.111s17.085-2.256,20.924-11.828.652-19.855-7.116-22.972-17.179,2.117-21.017,11.688",
    transform: "translate(-39.795 -5.655)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8185",
    "data-name": "Path 8185",
    d: "M459.4,100.252a12.494,12.494,0,0,1-2.437-.7A14.117,14.117,0,0,1,448.89,90.3a21.978,21.978,0,0,1,9.873-24.8,13.972,13.972,0,0,1,12.144-1.1c7.853,3.15,11.091,13.565,7.221,23.218a21.471,21.471,0,0,1-9.07,10.767,14.324,14.324,0,0,1-9.663,1.868M450,76.334a20.759,20.759,0,0,0-.744,13.851A13.744,13.744,0,0,0,457.1,99.2a13.408,13.408,0,0,0,11.773-1.145,21.091,21.091,0,0,0,8.905-10.577c3.792-9.459.648-19.654-7.01-22.726a13.6,13.6,0,0,0-11.819,1.075A20.739,20.739,0,0,0,450,76.334",
    transform: "translate(-39.776 -5.636)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8186",
    "data-name": "Path 8186",
    d: "M469.19,89.13a4.543,4.543,0,0,0,.242-1.488,4.5,4.5,0,0,0-.234-1.36,5.727,5.727,0,0,0-.621-1.249,9.948,9.948,0,0,0-.913-1.15,13.906,13.906,0,0,0-1.089-1.084c-.388-.355-.778-.7-1.177-1.055l2.088-6.416a3.747,3.747,0,0,1,1.555,1.473,4.757,4.757,0,0,1,.523,2.221l2.3.745a6.61,6.61,0,0,0-.025-2.264,5.647,5.647,0,0,0-.707-1.867,5.913,5.913,0,0,0-1.257-1.471,7.577,7.577,0,0,0-1.663-1.08l.675-2.058-2.33-.757-.669,2.061a7.323,7.323,0,0,0-2.122-.056,6.361,6.361,0,0,0-1.929.54,5.142,5.142,0,0,0-1.561,1.119,4.053,4.053,0,0,0-.293.34,4.5,4.5,0,0,0-.693,1.339,4.933,4.933,0,0,0-.172.681,3.859,3.859,0,0,0-.027,1.372,5.047,5.047,0,0,0,.652,1.8,8.012,8.012,0,0,0,.52.785c.1.124.2.251.3.377s.229.262.349.388c.022.026.04.042.062.068.5.509,1.021,1.013,1.564,1.509l-1.753,5.4-.075.233,0,.007-.071.227-.363,1.105a3.884,3.884,0,0,1-.89-.908,4.02,4.02,0,0,1-.444-.809c-.043-.093-.076-.19-.109-.287l-.007,0c-.008-.02-.013-.046-.021-.067-.021-.067-.04-.141-.057-.215a5.556,5.556,0,0,1-.2-1.154,6.557,6.557,0,0,1,.057-1.5l-2.446-.8a8.779,8.779,0,0,0-.083,2.243.155.155,0,0,0,0,.068c0,.058.011.112.014.163,0,.007,0,.01,0,.017a.3.3,0,0,1,.007.078,1.026,1.026,0,0,0,.032.179.3.3,0,0,0,.009.078,7.753,7.753,0,0,0,.531,1.908c.065.16.139.316.217.466a1.475,1.475,0,0,0,.136.248,2.336,2.336,0,0,0,.134.248,6.714,6.714,0,0,0,.674.949,6.383,6.383,0,0,0,1.685,1.42l-1.065,3.269,2.324.754,1.049-3.21a9.247,9.247,0,0,0,2.185.183,6.34,6.34,0,0,0,2.135-.444,5.29,5.29,0,0,0,1.813-1.2,5.133,5.133,0,0,0,1.226-2.107m-7.454-12.814a2.408,2.408,0,0,1,1.2-1.429,3.474,3.474,0,0,1,2.211-.287l-1.8,5.495a11.187,11.187,0,0,1-.854-.918,4.632,4.632,0,0,1-.6-.927,2.953,2.953,0,0,1-.277-.947,2.323,2.323,0,0,1,.113-.988m4.448,13.12a3.029,3.029,0,0,1-.943.718,3.932,3.932,0,0,1-1.235.371,4.78,4.78,0,0,1-1.452-.054l2.016-6.189a13.651,13.651,0,0,1,1,1.005,6.236,6.236,0,0,1,.793,1.041,3.5,3.5,0,0,1,.444,1.042,1.932,1.932,0,0,1-.042,1.035,3.036,3.036,0,0,1-.579,1.031",
    transform: "translate(-40.489 -6.239)",
    fill: "#040a2e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 13.544,
    transform: "translate(483.716 453.199)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 5.34,
    transform: "translate(472.147 453.199)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 467.836,
    transform: "translate(0.456 453.199)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransaction);
export default __webpack_public_path__ + "static/media/No_Transaction.1bfb78b00b1c0429ce517dc9e7dd254f.svg";
export { ForwardRef as ReactComponent };